import { yupResolver } from '@hookform/resolvers/yup'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useCreateFeedback } from '../../../../api/hooks/use.form.submission'
import { supportModalSchema } from '../schemas/support.modal.schema'
import SuccessIcon from './../../../../styles/icons/check-file.svg'
import * as styled from './styled'

export type SupportFormValues = {
  name: string
  contact: string
  message: string
}


type SupportModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const SupportModalComponent = ({ isOpen, onClose }: SupportModalProps) => {
  const [success, setSuccess] = useState(false)
  const { mutateAsync: createFeedback } = useCreateFeedback();
//  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
 // const [captchaError, setCaptchaError] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<SupportFormValues>({
    resolver: yupResolver(supportModalSchema),
    defaultValues: {
      name: '',
      contact: '',
      message: '',
    },
  })

   const handleClose = () => {
    setSuccess(false)
  //  setCaptchaToken(null)
   // setCaptchaError(false)
    reset()
    onClose()
  }

 const onSubmit = (data: SupportFormValues) => {
   // if (!captchaToken) return;
  
    setSuccess(true);
  
   // const dataWithCaptcha = { ...data, captchaToken};
  
    createFeedback(data, {
      onSuccess: () => setSuccess(true),
      onError: () => setSuccess(false),
    });
  };
  

  if (!isOpen) return null

  if (success) {
  return (
    <styled.Overlay onClick={handleClose}>
      <styled.SuccessModal onClick={e => e.stopPropagation()}>
        <styled.CloseButton onClick={handleClose}>×</styled.CloseButton>

        <styled.SuccessWrapper>
          <img src={SuccessIcon} alt="icon" />

          <styled.SuccessText>Надіслано</styled.SuccessText>
        </styled.SuccessWrapper>

      </styled.SuccessModal>
    </styled.Overlay>
  )
}

  return (
    <styled.Overlay onClick={handleClose}>
      <styled.FormModal onClick={e => e.stopPropagation()}>
        <styled.CloseButton type='button' onClick={handleClose}>
          ×
        </styled.CloseButton>

        <styled.Title>Звернення до служби технічної підтримки</styled.Title>

        <styled.Description>
          Виникли труднощі під час користування вебпорталом?
          <br />
          Залиште звернення до служби технічної підтримки, і ми допоможемо
          вирішити вашу проблему.
        </styled.Description>

        <styled.Form onSubmit={handleSubmit(onSubmit)}>
          <styled.Field>
            <styled.Label>
              Ваше Ім’я <span>*</span>
            </styled.Label>
            <styled.Input {...register('name')} $error={errors.name} />
            {errors.name && <styled.ErrorText>{errors.name.message}</styled.ErrorText>}
          </styled.Field>

          <styled.Field>
            <styled.Label>
              Ваш e-mail або телефон <span>*</span>
            </styled.Label>
            <styled.Input {...register('contact')}  $error={errors.contact} />
            {errors.contact && (
              <styled.ErrorText>{errors.contact.message}</styled.ErrorText>
            )}
          </styled.Field>

          <styled.Field>
            <styled.Label>
              Повідомлення <span>*</span>
            </styled.Label>
            <styled.Textarea {...register('message')} $error={errors.message}/>
            {errors.message && (
              <styled.ErrorText>{errors.message.message}</styled.ErrorText>
            )}
          </styled.Field>

           {/*
           
            <styled.CaptchaWrapper>
            <Turnstile
              siteKey={CONFIG.TURNSTILE_SITEKEY}
              onSuccess={token => {
                setCaptchaToken(token)
                setCaptchaError(false)
              }}
              onExpire={() => setCaptchaToken(null)}
              onError={() => {
                setCaptchaToken(null)
                setCaptchaError(true)
              }}
            />
            {captchaError && (
              <styled.ErrorText>Будь ласка, підтвердіть що ви не робот</styled.ErrorText>
            )}
          </styled.CaptchaWrapper>
           
           */}

          

         
          <styled.SubmitButton type='submit'>Надіслати</styled.SubmitButton>

          <styled.PrivacyText>
            Натискаючи кнопку «Надіслати», Ви погоджуєтесь з{' '}
            <styled.PrivacyLink to='/privacy-policy' target='_blank' rel='noopener noreferrer'>
              Політикою конфіденційності
            </styled.PrivacyLink>
          </styled.PrivacyText>
        </styled.Form>
      </styled.FormModal>
    </styled.Overlay>
  )
}